import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useGetChatSettingsLeaveGroupConversationProperties } from "./useGetChatSettingsLeaveGroupConversationProperties";
import ChatSettingsDetails from "@/components/chat/chatSettings/ChatSettingsDetails/ChatSettingsDetails.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatSettingsLeaveGroupConversation',
  setup(__props) {

const { leaveGroupConversationProperties } =
  useGetChatSettingsLeaveGroupConversationProperties();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ChatSettingsDetails, _normalizeProps(_guardReactiveProps(_unref(leaveGroupConversationProperties))), null, 16))
}
}

})